import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import {UserService} from "./user-service";
import {SessionService} from "./session-service";
import {HTTPCONSTANTS} from "../http/http-constants";

export default interface MarketWatchListItem {
  registration: string;
  sold_price: string;
  sold_date: Date;
  seller: string;
  formattedRegistration: string;
}

@Injectable({ providedIn: 'root' })
export class MarketWatchService {

  constructor(private httpClient: HttpClient, private snackbar: MatSnackBar, private userService: UserService) {}

  /** Fetches top sold for a given year (default: current year). */
  public GetTopSoldThiYear(callback: (results: MarketWatchListItem[]) => void, year?: number): void {
    const y = year ?? new Date().getFullYear();
    const url = `${HTTPCONSTANTS.dataApiProtocol}${HTTPCONSTANTS.dataApiBaseAddress}/MarketWatch/yearly-top-sold?year=${y}`;
    this.httpClient.get<MarketWatchListItem[]>(url).subscribe({
      next: (res: MarketWatchListItem[] | null) => {
        // 200 with null/empty body (e.g. 204 treated as success) -> show empty; ensure we pass an array
        callback(Array.isArray(res) ? res : []);
      },
      error: (err) => {
        console.error('MarketWatch yearly-top-sold failed:', err?.status ?? err?.message ?? err);
        callback(null);
      },
    });
  }
}
